import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';
import { INJURY_INSURANCE } from '../../../client/marketing';
import { sportTheme } from '../../../client/clientTheme';

type Variant = 'hero' | 'banner' | 'chip';

interface Props {
  variant?: Variant;
}

export default function InjuryInsuranceBadge({ variant = 'hero' }: Props) {
  if (variant === 'chip') {
    return (
      <Chip
        icon={<HealthAndSafetyOutlinedIcon sx={{ color: `${sportTheme.green} !important` }} />}
        label={INJURY_INSURANCE.headline}
        size="small"
        sx={{
          fontWeight: 700,
          bgcolor: 'rgba(0,200,83,0.15)',
          color: sportTheme.green,
          border: '1px solid rgba(0,200,83,0.4)',
        }}
      />
    );
  }

  if (variant === 'banner') {
    return (
      <Paper
        elevation={0}
        sx={{
          p: { xs: 2, sm: 2.5 },
          borderRadius: 3,
          bgcolor: 'rgba(255,255,255,0.96)',
          border: '1px solid rgba(0,200,83,0.35)',
          color: sportTheme.navy,
        }}
      >
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ alignItems: { sm: 'center' } }}>
          <Box
            sx={{
              width: 52,
              height: 52,
              borderRadius: 2,
              flexShrink: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'rgba(0,200,83,0.2)',
              color: sportTheme.green,
            }}
          >
            <HealthAndSafetyOutlinedIcon sx={{ fontSize: 28 }} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant="overline" sx={{ fontWeight: 800, letterSpacing: 1.5, color: sportTheme.green }}>
              Member benefit
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 900, lineHeight: 1.2 }}>
              {INJURY_INSURANCE.amount} injury insurance
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.88, mt: 0.5 }}>
              {INJURY_INSURANCE.description}
            </Typography>
          </Box>
        </Stack>
      </Paper>
    );
  }

  return (
    <Stack
      direction="row"
      spacing={1.5}
      sx={{
        alignItems: 'center',
        mt: 2,
        p: 1.5,
        borderRadius: 2,
        maxWidth: 520,
        bgcolor: 'rgba(0,200,83,0.12)',
        border: '1px solid rgba(0,200,83,0.35)',
      }}
    >
      <HealthAndSafetyOutlinedIcon sx={{ color: sportTheme.green, fontSize: 28, flexShrink: 0 }} />
      <Box>
        <Typography variant="subtitle2" sx={{ fontWeight: 800, lineHeight: 1.3 }}>
          {INJURY_INSURANCE.headline}
        </Typography>
        <Typography variant="caption" sx={{ opacity: 0.85 }}>
          {INJURY_INSURANCE.shortLine}
        </Typography>
      </Box>
    </Stack>
  );
}
